import React from 'react';

import Button from '@components/button/Button.tsx';
import Icon from '@components/icon/Icon.tsx';

import I from '../types.ts';

const renderContent: I['renderContent'] = function () {
    return (
        <div className="publicExecutorsHeader__content _col">
            <div className="publicExecutorsHeader__contentInfo _col">
                <h1 className="publicExecutorsHeader__title">
                    Работа курьером для&nbsp;самозанятых
                </h1>
                <p className="publicExecutorsHeader__description">
                    Платформа, где самозанятый из сферы логистики найдет подходящий заказ. Скачайте
                    приложение, заполните профиль и приступайте к работе
                </p>
                <a
                    className="publicExecutorsHeader__button"
                    href={this.joinLink}
                    target="_blank"
                    rel="noreferrer"
                >
                    <Button className="_main _public _shadow">
                        Зарегистрироваться{' '}
                        <i className="_arrowNext">
                            <Icon name="arrow-next-2" />
                        </i>
                    </Button>
                </a>
            </div>
            <div className="publicExecutorsHeader__contentMore">
                <i className="publicExecutorsHeader__contentMoreIcon">
                    <Icon name="info-more" />
                </i>
                Узнать
                <br />
                больше
            </div>
            {this.bubbles.map((bubble, key) => (
                <div className={`publicExecutorsHeader__contentBubble _${key + 1}`} key={key}>
                    <div className="publicExecutorsHeader__contentBubbleTitle">{bubble.title}</div>
                    <p
                        className="publicExecutorsHeader__contentBubbleDescription"
                        dangerouslySetInnerHTML={{ __html: bubble.description }}
                    ></p>
                </div>
            ))}
        </div>
    );
};

export default renderContent;
